<template>
  <div id="sizing-app">
    <transition :css="false"
                @before-enter="beforeEnter"
                @enter="enter"
                @after-enter="afterEnter">

      <div class="background-container" v-if="opened" @click.self="close" :class="{'sa-fade-in': opening}">
        <div class="main-screen" :class="{'sa-slide-down': opening}">
          <div class="close-btn" @click="close">&times;</div>

          <div class="main-container">
            <div class="left-container">
              <product-slider/>
            </div>

            <div class="right-container">
              <component :is="currentView"></component>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
import ProductSlider from "./components/ProductSlider";
import {mapGetters} from 'vuex';

import AgeAndFitView from './components/views/general/AgeAndFitView';
import Brands from './components/views/general/Brands';
import BraView from './components/views/female/BraView';
import ChestView from './components/views/male/ChestView';
import GeneralInfoView from './components/views/general/GeneralInfoView';
import HipsView from './components/views/female/HipsView';
import ResultView from './components/views/general/ResultView';
import RiseView from './components/views/female/RiseView';
import TummyView from './components/views/general/TummyView';
import WaistFitView from './components/views/male/WaistFitView';
import SendSelectionsView from "./components/views/general/SendSelectionsView";
import ThankYouView from "./components/views/general/ThankYouView";
import ApplyStyleOptions from './mixins/ApplyStyleOptionsMixin';
import EventBus from './services/EventBus';
import CustomEvents from './services/CustomEvents';
import ConfigurationService from './services/ConfigurationService';
import Amplitude from './plugins/Amplitude';

export default {
  components: {
    ProductSlider,

    // views
    AgeAndFitView,
    Brands,
    BraView,
    ChestView,
    GeneralInfoView,
    HipsView,
    ResultView,
    RiseView,
    TummyView,
    WaistFitView,
    SendSelectionsView,
    ThankYouView,
  },

  mixins: [ApplyStyleOptions],

  data() {
    return {
      opened: false,
      opening: false,

      bodyFixed: true,
    };
  },

  mounted() {
    this.bodyFixed = ConfigurationService.option('options.bodyFixed');

    EventBus.on('app.open', () => {
      this.open();
    });
    EventBus.on('app.close', () => {
      this.close();
    });
    EventBus.emit('app.ready');
  },

  computed: {
    ...mapGetters({
      currentView: 'navigation/getCurrentView',
    }),
  },

  methods: {
    open() {
      this.opened = true;

      if (this.bodyFixed) {
        document.body.style.position = 'fixed';
      }

      CustomEvents.trigger('sizingAppWasOpened');
      Amplitude.logEvent('open widget');
      window.addEventListener('keydown', this.closeOnEsc);
    },

    close() {
      this.opened = false;

      if (this.bodyFixed) {
        document.body.style.position = 'static';
      }

      CustomEvents.trigger('sizingAppWasClosed');
      Amplitude.logEvent('close widget');
      window.removeEventListener('keydown', this.closeOnEsc);
    },

    beforeEnter() {
      this.opening = true;
    },

    enter(el, done) {
      setTimeout(done, 600);
    },

    afterEnter() {
      this.opening = false;
    },

    closeOnEsc(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss">
  #sizing-app {
    @import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
    @import './assets/scss/main.scss';
  }
</style>
